export function debounce(func, time) {
  var time = time || 100; // 100 by default if no param
  var timer;
  return function (event) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(func, time, event);
  };
}

//Event Delegation
//attaches an event handler to a parent & checks if that event was triggered from a child.
//this can be used when the child elements might change, such as a listing updated via Ajax.
export function on(parentSelector, eventName, selector, fn) {
  var element = document.querySelector(parentSelector);
  if (element) {
    element.addEventListener(eventName, function (event) {
      var possibleTargets = element.querySelectorAll(selector);
      var target = event.target;

      for (var i = 0, l = possibleTargets.length; i < l; i++) {
        var el = target;
        var p = possibleTargets[i];

        while (el && el !== element) {
          if (el === p) {
            return fn.call(p, event, p);
          }

          el = el.parentNode;
        }
      }
    });
  }
}

// Determines if the passed element is overflowing its bounds,
// either vertically or horizontally.
// Will temporarily modify the "overflow" style to detect this
// if necessary.
export function checkHorizontalOverflow(el) {
  var curOverflow = el.style.overflow;

  if (!curOverflow || curOverflow === "visible") el.style.overflow = "hidden";

  var isOverflowing = el.clientWidth < el.scrollWidth;

  el.style.overflow = curOverflow;

  return isOverflowing;
}

//adjusts size/position of a video to ensure full coverage of the parent element
export function coverParent(el, ratioWidth, ratioHeight) {
  var parentWidth = el.parentElement.clientWidth;
  var parentHeight = el.parentElement.clientHeight;
  var parentRatio = parentWidth / parentHeight;
  var targetRatio = ratioWidth / ratioHeight;

  if (parentRatio >= targetRatio) {
    el.style.width = parentWidth + "px";
    el.style.height = parentWidth * (ratioHeight / ratioWidth) + "px";
  } else {
    el.style.width = parentHeight * (ratioWidth / ratioHeight) + "px";
    el.style.height = parentHeight + "px";
  }
}

//gets the index of a child node relative to it's nearest parent
export function getChildIndex(node) {
  return Array.prototype.indexOf.call(node.parentNode.children, node);
}

export function removeClassesWithSuffix(node, suffix) {
  var classes = node.className.split(" ").filter(function (c) {
    return c.lastIndexOf(suffix) !== c.length - suffix.length;
  });
  node.className = classes.join(" ").trim();
}

export function getScreenWidth() {
  return (
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth
  );
}

export function getScreenHeight() {
  return (
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight
  );
}

export function scrollTo(Y, callback) {
  //https://gist.github.com/SgtPooki/6a9bf70ccd97750e0d57

  var start = Date.now(),
    elem = document.documentElement,
    from = elem.scrollTop,
    easingFunction = function (t) {
      return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    }; //easing fixed as easeInOutCubic. This was the closest to the cubic-bezier easing used for large items in CSS

  if (from === Y && typeof callback === "function") {
    callback();
    return; /* Prevent scrolling to the Y point if already there */
  }

  function min(a, b) {
    return a < b ? a : b;
  }

  function scroll(timestamp) {
    var currentTime = Date.now(),
      time = min(1, (currentTime - start) / 600), //duration fixed at 600ms
      easedT = easingFunction(time);

    elem.scrollTop = easedT * (Y - from) + from;

    if (time < 1) requestAnimationFrame(scroll);
    else if (callback && typeof callback === "function") callback();
  }

  requestAnimationFrame(scroll);
}

export function getPassedTime({
  timestamp,
  justNow,
  minsAgo,
  hoursAgo,
  daysAgo,
}) {
  const currentDate = Date.now();
  const date = Date.parse(timestamp);

  if (isNaN(date)) {
    return;
  }

  const passedMinutes = Math.floor((currentDate - date) / 1000 / 60);
  const passedHours = Math.floor(passedMinutes / 60);
  const passedDays = Math.floor(passedHours / 24);

  if (passedMinutes < 10) {
    return justNow;
  }

  if (passedMinutes < 60) {
    return `${passedMinutes} ${minsAgo}`;
  }

  if (passedHours < 24) {
    return `${passedHours}${hoursAgo}`;
  }

  return `${passedDays}${daysAgo}`;
}
